import { useMemo } from 'react'

import signupApi from '@api/signUp'

import { useStatefulMutation } from '../mutation'

const baseKey = 'brid'

export const useBrid = () => {
  const queryKey = useMemo(() => [baseKey], [])
  const checkBridExistsKey = useMemo(
    () => [...queryKey, 'checkBridExists'],
    [queryKey]
  )

  const checkBridExistsMutation = useStatefulMutation(
    async (bridData) => await signupApi.checkBridExists(bridData),
    {
      mutationKey: checkBridExistsKey,
      onSuccess: (data, variables) => ({
        data,
        variables,
      }),
    }
  )

  return {
    checkBridExists: checkBridExistsMutation.mutateAsync,
    checkBridExistsState: checkBridExistsMutation.state,
  }
}
